import { takeLatest, all } from 'redux-saga/effects';

import { GET_VLEARN_APP_URL_REQUEST } from '@store/dashboard/dashboard.const';

import { handleAppRequestSaga } from './handleAppRequestSaga';

export default all([takeLatest(GET_VLEARN_APP_URL_REQUEST, handleAppRequestSaga)]);
